import { Outlet } from "react-router";
import { useState } from "react";
import { useRefreshTokenQuery } from "../../api/auth/authApi";
import { selectCurrentToken, selectCurrentUser, setCredentials } from "../../api/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoadingScreen } from "../utils/LoadingScreen"; 

export const PersistLogin = () => {
    const currentToken = useSelector(selectCurrentToken);
    const dispatch = useDispatch();
    const [skip, setSkip] = useState(() => currentToken != null)

    const { data, isLoading, isError } = useRefreshTokenQuery(undefined, {
        skip: skip,
    });

    if(!skip && !isLoading && !isError && data) {

        const userState = {
            token: data.token,
            user: data.user 
        }

        dispatch(setCredentials(userState))
    }

    return (
        <>
        {isLoading
            ? <LoadingScreen />
            : <Outlet />
        }
        </>
    );

}
